import { render, staticRenderFns } from "./SortDefinition.vue?vue&type=template&id=5af9b806&scoped=true"
import script from "./SortDefinition.vue?vue&type=script&lang=js"
export * from "./SortDefinition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af9b806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af9b806')) {
      api.createRecord('5af9b806', component.options)
    } else {
      api.reload('5af9b806', component.options)
    }
    module.hot.accept("./SortDefinition.vue?vue&type=template&id=5af9b806&scoped=true", function () {
      api.rerender('5af9b806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/catalogs/SortDefinition.vue"
export default component.exports